angular.module('widget-payments', ['ngTouch'])
    .directive('wgMobile', ['$state', 'configs', 'Localization','$rootScope', 'Pay', wgMobileDirective])
    .directive('wgP2pCard', ['$state', 'configs', 'Localization', wgP2pCardDirective])
    .directive('wgInternetTv', ['$state', 'configs', 'PortalApi', 'Localization', wgInternetTvDirective])
    .directive('wgCommunal', ['$state', 'configs', 'Localization', wgCommunalDirective])
    .directive('wgCredit', ['$state', 'configs', 'Localization', wgCreditDirective]);

function wgCreditDirective($state, configs, Localization) {

    return {
        restrict: 'A',
        template: require('./templates/wg_credit.html'),
        scope: true,
        link: postLink
    };

    function postLink(scope) {
        scope.submit = function () {
            var fields = {},
                serviceId = configs.payments_config.service.CreditFUIB;

            var data = {
                serviceId: serviceId,
                url: serviceId,
                fields: fields,
                amount: scope.amount,
                autoCheck: true,
                templateId: true
            };

            fields.account = {value: scope.account};
            fields.inn = {value: scope.inn};

            $state.go('pages.payment', data);
        };
    }
}

function wgCommunalDirective($state, configs, Localization) {
    return {
        restrict: 'A',
        template: require('./templates/wg_communal.html'),
        scope: true,
        link: function (scope, element, attrs) {
            var config = configs.comunn;
            scope.toService = function(i) {
                scope.spinn = true;

                $state.go('pages.payment', {
                    serviceId:  config[i].serviceId,
                    url:  config[i].serviceId,
                    fields: [],
                    amount: 0,
                    autoCheck: false
                });
            };
            scope.submit = function () {
                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.COMMUNAL_PAYMENT', 5, true);
            };
        }
    }
}

function wgInternetTvDirective($state, configs, PortalApi, Localization) {
    return {
        restrict: 'A',
        template: require('./templates/wg_internet_tv.html'),
        scope: true,
        link: postLink
    };

    function postLink(scope, element, attrs) {
        function init() {
            var sids = [];

            configs.internet.forEach(function (service) {
                sids.push(service.serviceId);
            });

            PortalApi.searchServices({
                query: '',
                limit: 10,
                sortByPayments: true,
                category: [34] // internet services category
            }).then(function (response) {
                scope.serviceProviders = response;
                scope.preLoader = false;
            });
        }

        scope.submit = function () {

            var fields = {};
            var serviceId = scope.providerForm.serviceId;

            configs.internet.forEach(function (service) {
                if (service.serviceId == serviceId) {
                    fields[service.fields.account] = {
                        value: scope.providerForm.account
                    }
                }
            });

            configs.internet.forEach(function (service) {
                if (service.serviceId == serviceId) {
                    if ((service.payments && service.payments.min && service.payments.max) && (scope.providerForm.summ < service.payments.min || scope.providerForm.summ > service.payments.max)) {

                        Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.MAX_SUMM_ERROR', 5, true);

                    } else {
                        scope.spinn = true;
                        $state.go('pages.payment', {
                            serviceId: serviceId,
                            url: serviceId,
                            amount: scope.providerForm.summ,
                            fields: fields

                        });
                    }
                }
            });


        };

        init();
    }
}

function wgMobileDirective($state, configs, Localization, $rootScope, Pay) {
    return {
        restrict: 'A',
        template: require('./templates/wg_mobile.html'),
        scope: true,
        link: postLink
    };

    function postLink(scope, element, attrs) {

        var config = scope.phoneSelect = configs.mobile_phone_pay;

        scope.Pay = Pay;
        scope.phoneSelect = config;

        function init() {
            if (localStorage.mobileWidgetPhone && localStorage.mobileWidgetAmount) {
                scope.phone = scope.Pay.selectedPhone.phone = localStorage.mobileWidgetPhone;
                scope.amount = localStorage.mobileWidgetAmount;
            }
        }

        scope.submit = function () {
            var info = config[0],
                fields = {};
            if (!info) {
                Localization.notifyTemplate('error', 'NOTIFICATION.ERRORS.MOBILE_OPERATOR_E', 5, true);
            }

            fields[info.fields.phone] = {
                value: '380' + scope.phone
            };

            scope.amount = Number(String(scope.amount).replace(",", "."));

            if (scope.amount > info.payments.max) {
                Localization.notifyTemplate('error', 'ERRORS.AMOUNT_LIMITS_MAX_ERROR', 5, true);
            }else if (scope.amount < info.payments.min) {
                Localization.notifyTemplate('error', 'ERRORS.AMOUNT_LIMITS_MIN_ERROR', 5, true);
            }else{
                scope.spinn = true;
                localStorage.mobileWidgetPhone = scope.phone;
                localStorage.mobileWidgetAmount = scope.amount;
                $state.go('pages.payment', {
                    serviceId: info.serviceId,
                    url: info.serviceId,
                    fields: fields,
                    amount: scope.amount,
                    autoCheck: true,
                    templateId: true
                });
            }
        };

        scope.pastePhoneNmb = function(e) {
            scope.Pay.selectedPhone.phone = '';
            var paste = e.originalEvent.clipboardData.getData('text/plain').replace(/[()\s+\W+]/g, ''),
                cut;
            if (paste.length > 9) {
                cut = paste.substring(paste.length - 9);
                scope.phone = scope.Pay.selectedPhone.phone = cut;
            }
        };
        init();
    }
}

function wgP2pCardDirective($state) {
    return {
        restrict: 'A',
        template: require('./templates/wg_p2p_card.html'),
        scope: true,
        link: postLink
    };

    function postLink(scope, element, attrs) {
        scope.submit = function () {
            $state.go('pages.cardtocard', {

                target: scope.targetCard,
                amount: scope.amount
            });
        };
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/widget-payments.js
 ** module id = 304
 ** module chunks = 1
 **/